import { render, staticRenderFns } from "./cLight.vue?vue&type=template&id=dc218e64&scoped=true&"
import script from "./cLight.vue?vue&type=script&lang=js&"
export * from "./cLight.vue?vue&type=script&lang=js&"
import style0 from "./cLight.vue?vue&type=style&index=0&id=dc218e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc218e64",
  null
  
)

export default component.exports